const CALENDAR_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})/;

/** Extract YYYY-MM-DD from an API value without timezone conversion. */
export const toDateInputValue = (value) => {
    if (!value) return '';
    const match = String(value).match(CALENDAR_DATE_RE);
    return match ? `${match[1]}-${match[2]}-${match[3]}` : '';
};

/** Format a calendar date for display (ignores time/timezone on ISO strings). */
export const formatCalendarDate = (value) => {
    if (!value) return '—';
    const match = String(value).match(CALENDAR_DATE_RE);
    if (!match) return String(value);
    const [, y, m, d] = match;
    const date = new Date(Number(y), Number(m) - 1, Number(d));
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
};

/** Compare calendar dates given as YYYY-MM-DD strings. */
export const compareCalendarDates = (a, b) => {
    if (a === b) return 0;
    return a < b ? -1 : 1;
};

const toDate = (value) => {
    if (!value) return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

const intlFormat = (date, timeZone, options) => {
    try {
        return new Intl.DateTimeFormat('en-GB', {
            ...(timeZone ? { timeZone } : {}),
            ...options,
        }).format(date);
    } catch {
        // Invalid timeZone — fall back to the local zone.
        return new Intl.DateTimeFormat('en-GB', options).format(date);
    }
};

/** Format a timestamp's date as dd/MM/yyyy in the given IANA timezone (local if omitted). */
export const formatDateInTimeZone = (value, timeZone) => {
    const date = toDate(value);
    if (!date) return '';
    return intlFormat(date, timeZone, { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/** Format a timestamp's time as HH:mm in the given IANA timezone (local if omitted). */
export const formatTimeInTimeZone = (value, timeZone) => {
    const date = toDate(value);
    if (!date) return '';
    return intlFormat(date, timeZone, { hour: '2-digit', minute: '2-digit', hour12: false });
};

/** Full date-time including the timezone abbreviation, e.g. "30/06/2026, 14:30 BST". */
export const formatDateTimeInTimeZone = (value, timeZone) => {
    const date = toDate(value);
    if (!date) return '';
    return intlFormat(date, timeZone, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZoneName: 'short',
    });
};
